import { Component } from '@angular/core';
import { NavController, NavParams,LoadingController,ModalController} from 'ionic-angular';
import * as moment from 'moment';
import {AddRequestPage} from "./add/add";
import * as firebase from 'firebase/app';
import {Params} from "../../params";
import {ActionRequestsPage} from "./action/action";
/**
 * Generated class for the RequestsPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-requests',
  templateUrl: 'requests.html',
})
export class RequestsPage {
  month;
  years = [];
  year;
  requests = [];
  accounts;
  items;
  customers;
  first : boolean  = true;
  foods = {
    list : [],
    data : {}
  };
  plans = {
    list : [],
    data : {}
  };
  statuses = {
    0 : "Pendiente de Aprobación",
    1 : "Procesada",
    2 : "Rechazada",
  };
  types = {}

  constructor(
    public navCtrl: NavController,
    public loadingCtrl : LoadingController,
    public modalCtrl : ModalController,) {
    this.types = Params.REQUEST_TYPES;
    console.log('init requests')
    let actual_year = Number(moment().format("YYYY"));
    let first_year = 2017;
    let end = (actual_year-first_year)+2;
    for(let y=0;y<end;y++){
      this.years.push(first_year+y);
    }

    this.month = moment().format("MM");
    this.year = actual_year;
    firebase.database().ref('/foods').once('value').then((snapshot)=>{
      this.foods.list = (<any>Object).values(snapshot.val());
      this.foods.data = snapshot.val();
    });
    firebase.database().ref('/plans').once('value').then((snapshot)=>{
      this.plans.list = (<any>Object).values(snapshot.val());
      this.plans.data = snapshot.val();
    });
    firebase.database().ref('/accounts').once('value').then((snap1)=> {
      this.accounts = snap1.val();
      firebase.database().ref('/customers').once('value').then((snap2)=> {
        this.customers = snap2.val();
        this.filter(true);
      });

    });
  }

  ionViewDidEnter() {
    if(!this.first) this.filter(false);
  }

  format(date,hour){
    if(hour){
      return moment(date).format("DD MMMM YY HH:mm:ss");
    }else{
      return moment(date).format("DD MMMM YY");
    }
  }

  action(action,request){
    let modal = this.modalCtrl.create(ActionRequestsPage, {action:action,request:request,types:this.types,statuses:this.statuses,foods :this.foods,plans:this.plans});
    modal.present();
    modal.onDidDismiss(data => {
      this.filter(false);
    });
  }

  add(){
    this.navCtrl.push(AddRequestPage,{foods: this.foods,plans:this.plans});
  }

  filter(first){
    let loading = this.loadingCtrl.create({
      content: 'Buscando solicitudes...'
    });
    loading.present();
    let first_date = this.year+"-"+this.month+"-01";
    let last_day = Number(moment(first_date).endOf('month').format('DD'));
    let canc = [];
    let total = 0;
    for(let d=1;d<=last_day;d++){
      let day = Params.number_two_digits(d);
      let date = this.year+this.month+day;
      firebase.database().ref('/requests/'+date).once('value').then((snap1)=> {
        total++;
        if(snap1.exists()){
          let data = snap1.val();
          for(let customerid in data){
            let requests = data[customerid];
            for(let requestid in requests){
              let obj = requests[requestid];
              obj["requestid"] = requestid;
              obj["customerid"] = customerid;
              obj["customerName"] = this.customers[customerid].name.trim()+" "+this.customers[customerid].lastname.trim();
              obj["customerData"] = this.customers[customerid];
              obj["ownerName"] = this.accounts[obj.owner] ? this.accounts[obj.owner].name: "N/A";
              obj["date"] = date;
              obj["dateformat"] = this.year+this.month+day;
              canc.push(obj);
            }
          }
        }
        if(total==last_day){
          loading.dismiss();
          this.requests = canc;
          this.initializeItems();
          console.log(canc);
          if(first) this.first = false;
        }
      });
    }
  }

  initializeItems() {
    this.items = this.requests;
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (item.customerName.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RequestsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/changes/requests/requests.ts